module.exports = __webpack_public_path__ + "img/register.5cf8b5d6.svg";